import { Component, OnInit } from '@angular/core';
import {UserData} from "@data/users";
import {NbDialogService, NbMenuService} from "@nebular/theme";
import {CognitoService} from "@services/cognito.service";
import {Router} from "@angular/router";
import {AccountService} from "@services/account-service";
import {CommonConstant} from "@services/common-constant";
import {AppUser} from "@data/schema/account/app-user";
import {ProfileComponent} from "@layout/profile/profile.component";
import {Subscription} from "rxjs";
import {  faChalkboard } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'ngx-dashboardlayout-header',
  templateUrl: './dashboardlayout-header.component.html',
  styleUrls: ['./dashboardlayout-header.component.scss']
})
export class DashboardlayoutHeaderComponent implements OnInit {

  constructor(private userService: UserData,
              private menuService: NbMenuService,
              private cognitoService: CognitoService,
              private router: Router,
              private accountServices : AccountService,
              private commonConstaant : CommonConstant,
              private dialogService: NbDialogService,
             ) { }
  userMenu = [ { title: 'Profile' }, { title: 'Log out' } ];
  user: AppUser = new AppUser();
  userPictureOnly: boolean = false;
  isSettingsViewAllowed = false;
  isContactsViewAllowed = false;
  isReportViewAllowed = false;
  isTrainingViewAllowed = false;
  isLoanOriginatorDashboardViewAllowed = false;
  loanApplicationEventEmitterSubscription: Subscription;
  leftArrow = faChalkboard;


  ngOnInit(): void {
    this.user = this.cognitoService.getAppUser();
    this.menuService.onItemClick().subscribe(item=>{
      if(item.item.title === 'Log out'){
        this.cognitoService.signOut().then((value) => {
          this.cognitoService.removeUserData();
          this.router.navigate(['/auth']);
        });;


      }
      if(item.item.title === 'Profile'){
        this.dialogService.open(ProfileComponent, {
          context: {
            name: this.user.firstName + ' ' + this.user.lastName,
            email: this.user.email,
            mobile: '',
            profileLink: '',
          }
        });
        }
    })
    this.loadPermissions();
   }

  loadPermissions(){
    this.isSettingsViewAllowed = this.accountServices.
    isAllowed(this.commonConstaant.UserPermissionNounType.Settings,
      this.commonConstaant.UserPermissionVerbType.View,this.cognitoService.getAppUser());
    this.isContactsViewAllowed = this.accountServices.
    isAllowed(this.commonConstaant.UserPermissionNounType.Contacts,
      this.commonConstaant.UserPermissionVerbType.View,this.cognitoService.getAppUser());
    this.isReportViewAllowed = this.accountServices.
    isAllowed(this.commonConstaant.UserPermissionNounType.Reports,
      this.commonConstaant.UserPermissionVerbType.View,this.cognitoService.getAppUser());
    this.isTrainingViewAllowed = this.accountServices.
    isAllowed(this.commonConstaant.UserPermissionNounType.Training,
      this.commonConstaant.UserPermissionVerbType.View,this.cognitoService.getAppUser());
    this.isLoanOriginatorDashboardViewAllowed = this.accountServices.
    isAllowed(this.commonConstaant.UserPermissionNounType.LoanOriginatorDashboard,
      this.commonConstaant.UserPermissionVerbType.View,this.cognitoService.getAppUser());
  }

  navigateTo() {
    this.router.navigate(['/settings/settings-home']);
  }
  navigateToContacts(){
    this.router.navigate(['/contacts/contacts-home'])
  }
}
